export const AboutData = {
  aboutTitle: function () {
    return (
      <>
        <span style={{ color: "#10040E" }}>Tu deții </span>
        <span style={{ color: "red" }}>controlul</span>
      </>
    );
  },
  aboutParagraphs: function () {
    return (
      <>
        <p style={{ marginBottom: "15px" }}>
          Părerea ta este elementul esențial în luarea unei decizii corecte.
          Consultarea clientului este primul pas pe care îl parcurgem în
          analizarea problemei, iar pe tot parcursul procesului ținem legătura
          în permanență.
        </p>
      </>
    );
  },
};
